import { cloneDeep, get, isArray, set } from 'lodash';
import { KOSTEN_ARTEN, NACHWEIS_POSITION_STATUS } from 'src/lib/constants/constant';
import { addIndexesToPath } from 'src/utils/helper';

// import Schemas
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import NachweisPositionSchema from 'src/lib/paths/nachweisposition_FULL_Paths.json';
const P = MittelabrufSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

export function sumNachweispositionen(nachweisPositionen: any[], kostenart: string, status: string): number {
	return (nachweisPositionen as any[]).reduce((sum: number, eachPosition: any) => {
		const istKostenart = get(eachPosition, NP_P.Allgemein_Kostenart_Finanzierung.path) === kostenart;
		const istStatus = get(eachPosition, NP_P.Allgemein_Status.path) === status;
		if (!istKostenart || !istStatus) return sum;
		const ausgaben = Number(get(eachPosition, NP_P.Allgemein_Ausgaben_Kosten.path, 0)) || 0;
		return sum + ausgaben;
	}, 0);
}

export function executeKreativMAFormulas(application: any) {
	let result: any[] = [];
	let appCopy = cloneDeep(application);

	let calculatedPersonalAusgaben = calculatePersonalAusgaben(appCopy);
	if (isArray(calculatedPersonalAusgaben)) {
		for (let ele of calculatedPersonalAusgaben) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}

	result.push(...calculatedPersonalAusgaben);

	const calculatedKreativAusgaben = calculateKreativAusgaben(appCopy);
	if (isArray(calculatedKreativAusgaben)) {
		for (const ele of calculatedKreativAusgaben) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}

	result.push(...calculatedKreativAusgaben);
	const calculatedFoerderung = calculateFoerderung(appCopy);
	if (isArray(calculatedFoerderung)) {
		for (const ele of calculatedFoerderung) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}

	result.push(...calculatedFoerderung);

	return result;
}

function calculatePersonalAusgaben(application: any) {
	let result: any[] = [];

	const allNachweisPosition = get(application, P.Mittelabruf_Nachweispositions.path, []);

	for (let i = 0; i < allNachweisPosition.length; i++) {
		const eachPosition = allNachweisPosition[i];

		if (get(eachPosition, NP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten) {
			const anzahlStunden = get(eachPosition, NP_P.Stundennachweis_Gesamtstunden.path, 0);
			const stundenSatz = get(eachPosition, NP_P.Stundennachweis_Stundensatz.path, 0);

			const anzahlStundenNum = parseFloat(anzahlStunden);
			const stundenSatzNum = parseFloat(stundenSatz);

			const zuwendFaehigeBetrag = anzahlStundenNum * stundenSatzNum;
			console.log(' zuwendung fähige ausgaben for index ', i, ': ', zuwendFaehigeBetrag);

			result.push({
				path: addIndexesToPath(
					P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Ausgaben_Kosten.path,
					[`${i}`],
					['Mittelabruf_Nachweispositions'],
				),
				value: isFinite(zuwendFaehigeBetrag) ? zuwendFaehigeBetrag.toFixed(2) : '0.00',
			});
		}
	}

	return result;
}

function calculateKreativAusgaben(application: any) {
	const result: any[] = [];
	const updatedPositionen = get(application, P.Mittelabruf_Nachweispositions.path, []);
	const personalAngefallen = sumNachweispositionen(
		updatedPositionen,
		KOSTEN_ARTEN.Personalkosten,
		NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben,
	);
	const sachAngefallen = sumNachweispositionen(updatedPositionen, KOSTEN_ARTEN.Sachkosten, NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	const personalGeplant = sumNachweispositionen(updatedPositionen, KOSTEN_ARTEN.Personalkosten, NACHWEIS_POSITION_STATUS.geplant);
	const sachGeplant = sumNachweispositionen(updatedPositionen, KOSTEN_ARTEN.Sachkosten, NACHWEIS_POSITION_STATUS.geplant);
	const projektAusgabenAngefallen = personalAngefallen + sachAngefallen;
	const projektAusgabenGeplant = personalGeplant + sachGeplant;

	result.push(
		{ path: P.Kreativ_Angefallene_Ausgaben.path, value: projektAusgabenAngefallen.toFixed(2) },
		{ path: P.Kreativ_Anfallende_Ausgaben.path, value: projektAusgabenGeplant.toFixed(2) },
		{ path: P.Kreativ_Gesamt.path, value: (projektAusgabenAngefallen + projektAusgabenGeplant).toFixed(2) },
	);

	return result;
}

const calculateFoerderung = (application: any) => {
	let result: any = [];
	const foerderquote = get(application, P.Foerderantrag.schema.attributes.Allgemein_Foerderquote_Gesamt.path, 0);
	const projektausgabenGesamt = get(application, P.Kreativ_Gesamt.path, 0);
	const zuwendungAnteilig = projektausgabenGesamt * (foerderquote / 100);
	// const Anforderungsbetrag =
	// 	zuwendungAnteilig - parseFloat(get(application, P.Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr.path, '0'));
	const foerderung = Number(get(application, P.Ermittlung_Des_Auszahlungsbetrages_Bewilligte_Zuwendung.path, 0)) || 0;
	const bereitsAusgezahlt = Number(get(application, P.Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr.path, 0)) || 0;
	// const berechneteMaxFoerderungRaw = Number(get(application, MA_P.Ermittlung_Des_Auszahlungsbetrages_Anforderungsbetrag.path, 0)) || 0;
	const verfuegbareFoerderungDiesesHaushaltsjahr = Math.max(0, foerderung - bereitsAusgezahlt);
	const berechneteMaxFoerderung = Math.min(zuwendungAnteilig, verfuegbareFoerderungDiesesHaushaltsjahr);
	result.push(
		{
			path: P.Zuwendung_Anteilig_Gesamt.path,
			value: !isNaN(zuwendungAnteilig) ? zuwendungAnteilig.toFixed(2) : 0,
		},
		{
			path: P.Ermittlung_Des_Auszahlungsbetrages_Zuwendung_Anteilig.path,
			value: !isNaN(zuwendungAnteilig) ? zuwendungAnteilig.toFixed(2) : 0,
		},
		{
			path: P.Ermittlung_Des_Auszahlungsbetrages_Anforderungsbetrag.path,
			value: !isNaN(berechneteMaxFoerderung) ? berechneteMaxFoerderung.toFixed(2) : 0,
		},
	);

	return result;
};
